// @ts-ignore
import React from "react";
import "./NoticeBox.css";

const NoticeBox = ({
  message = "Oops! An error occured, try refreshing",
  icon = "info",
  align = "center",
  showText = true,
  noLeftMargin = false,
  forceFullWidth = false,
}: {
  message?: string;
  icon?: string;
  align?: "left" | "center";
  showText?: boolean;
  noLeftMargin?: boolean;
  forceFullWidth?: boolean;
}) => {
  return (
    <div
    id="notice"
    className={`${align === "center" ? "notice__center" : ""} ${!showText ? "notice__notext" : ""} ${
      noLeftMargin ? "notice__leftmargin" : ""
    } ${forceFullWidth ? "notice__fullwidth" : ""}`}>
      <div className="notice__icon">
        <span className="material-icons">{icon}</span>
      </div>

      <p className="notice__text">{message}</p>
    </div>
  );
};

export default NoticeBox;
